import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { BillingV2Service, ContextService, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Collection, CollectionLicenseEnum, Meeting, UserService } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-collection-license-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionDetailComponent extends ChangableComponent {
  @Input() public set content(value: Meeting | UserService | Collection) {
    this.collection = value as Collection;
  }

  @Output()
  public selected = new EventEmitter<CollectionLicenseEnum>();

  @Output()
  public pay = new EventEmitter<boolean>();
  public collection: Collection;
  public debug$ = this.contextService.debug$;
  public licenses = [
    CollectionLicenseEnum.personal,
    CollectionLicenseEnum.professional,
    CollectionLicenseEnum.business,
  ];

  constructor(
    private billingV2Service: BillingV2Service,
    private contextService: ContextService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
    public deviceService: DeviceDetectorService,
  ) {
    super(cdr, platform);
  }

  public get isAuthor(): boolean {
    return this.collection.visit_info?.is_author;
  }

  public getFormattedPrice(amount: number, discount?: number): Observable<string> {
    return this.billingV2Service.formatAmount$(amount, discount);
  }

  public get isMultiLicense(): boolean {
    return Object.values(this.collection?.price_tiers || {}).filter((price) => price > 0).length > 1;
  }

  public get hasLicensePersonal(): boolean {
    return this.hasLicense(CollectionLicenseEnum.personal);
  }

  public get hasLicenseProfessional(): boolean {
    return this.hasLicense(CollectionLicenseEnum.professional);
  }

  public get hasLicenseBusiness(): boolean {
    return this.hasLicense(CollectionLicenseEnum.business);
  }

  public get collectionLicenseEnum(): typeof CollectionLicenseEnum {
    return CollectionLicenseEnum;
  }

  public isPurchasedLicence(license): boolean {
    return this.collection?.visit_info?.licensed >= license;
  }

  protected hasLicense(license: CollectionLicenseEnum): boolean {
    const price_tiers = this.collection?.price_tiers || {};
    return (price_tiers[license] || 0) > 0;
  }

  public onPay(license) {
    this.selected.emit(license);
    this.pay.emit(true);
  }

  public trackByFn(index) {
    return index;
  }
}
